import { render, staticRenderFns } from "./axesChats.vue?vue&type=template&id=54040c64&scoped=true"
import script from "./axesChats.vue?vue&type=script&lang=js"
export * from "./axesChats.vue?vue&type=script&lang=js"
import style0 from "./axesChats.vue?vue&type=style&index=0&id=54040c64&prod&lang=css"
import style1 from "./axesChats.vue?vue&type=style&index=1&id=54040c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54040c64",
  null
  
)

export default component.exports